
import { init as initTrackJS } from './trackjs-agent';
import { init as initSentry } from './sentry-agent';

const noop = () => Promise.resolve();

// init :: Events -> ImdSettings -> Promise ImdSettings
export const init = events => imdSettings => {
  const { trackjs, sentry } = imdSettings.integration;
  const initTracker =
    !imdSettings.error_tracking ? noop :
      trackjs ? initTrackJS :
        sentry ? initSentry :
          () => Promise.resolve();

  return initTracker(events, imdSettings)
    .catch(e => console.error('Error tracking init failed', e))
    .then(() => imdSettings);
};
